import React from "react";
import "./App.css";
import AppRoutes from "./ui/layout/AppRoutes";
import MToaster from "@ui/components/toaster";
import Loader from "@ui/components/loader";
import { useSignalR } from "@ui/hooks/useSignalR";
const App = () => {
    // Initialize global SignalR connection - this will connect once when user authenticates
    // and stay connected throughout the application lifecycle
    useSignalR();
    return (React.createElement("div", { style: { width: "100%", height: "100%" } },
        React.createElement(MToaster, null),
        React.createElement(Loader, null),
        React.createElement(AppRoutes, null)));
};
export default App;
